import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/library/workflows/')({
  beforeLoad: () => {
    throw redirect({ to: '/library' })
  },
})
